import React, { useState , useEffect } from 'react';
import Users_In_Group from '../ChatGroups_Cust/Users_In_Group';
import { Card, CardBody, ListGroup, ListGroupItem, Row, Col, Input, CardHeader, Button } from "reactstrap";
import User from '../../assets/images/account.png';
import avatar2 from "../../assets/images/users/avatar-2.jpg";
import { useSelector } from 'react-redux';
import Add_New_User_modal from '../../Components/Common/CustomModal/UserModal/Add_New_User_modal';
import Edit_role_modal from '../../Components/Common/CustomModal/UserModal/Edit_role_modal';
import { close_confirm_modal, open_confirm_modal } from '../../slices/Confirm_Modal/reducer';
import { waitForDecision } from '../../utility/wait_for_confirmation';
import { Delete_Bot_User, Get_Bot_User_List } from '../../slices/thunks';
import { useDispatch } from 'react-redux';





const BotUser = () => {
    
    const dispatch = useDispatch()
    const { Bot_User } = useSelector((state)=> state.BotDetails)
    const { Bot_ID , User_Role   } = useSelector((state) => state.BotDetails.Bot_Details);
    const [bot_user, setbot_user] = useState(Bot_User)

    useEffect(() => {

        
       

        setbot_user(Bot_User)
    
   
    }, [Bot_User])


    useEffect(() => {
         dispatch(Get_Bot_User_List({ bot_id:Bot_ID }))
    }, [Bot_ID])
    


const serach_by_user_name = (e) =>{
   
    const user_name = e.target.value 

    const temp_users = Bot_User.filter(user => user.USER_NAME.includes(user_name))

    setbot_user(temp_users)
}


const serach_by_user_role = (e) =>{
   
    const user_role = e.target.value 

    const temp_users = Bot_User.filter(user => user.Type.includes(user_role))

    setbot_user(temp_users)
}


const onClick_Delete_User_From_Bot = async (ele)=>{
    dispatch(open_confirm_modal('Are you sure , you want to delete this user from bot'))
    const decision = await waitForDecision()
    if(decision){
        dispatch(Delete_Bot_User({ Bot_ID:Bot_ID , User_ID:ele.Bot_User_ID  }))
    }

    dispatch(close_confirm_modal())
}


    



  return (
    <div className='botuser'>
        
        <Card className='no_border'>
            <CardBody>
                <div className="d-flex mb-4 align-items-center">
                    <div className="flex-grow-1">
                        <h5 className="card-title mb-1">Number of Users in this Bot</h5>
                    </div>
                    <div className="float-end flex-shrink-0">
                        <img src={User} alt="" className="avatar-sm rounded-circle" />
                    </div>                                        
                </div>
            </CardBody>
            <div className="card-footer pbt_0">
                <h3><b>{bot_user.length}</b></h3>
            </div>
        </Card>
        <Card className='botuser_list_card'>
            <CardHeader className='no_border_bot'>
                <div className="d-flex align-items-center">
                    <div className="flex-shrink-0">
                        <h6 className="card-title mb-0">User List</h6>
                    </div>
                    <div className="flex-grow-1 ms-2" >
                       {/* <button type="button" className="rounded-pill btn btn-primary float-end fs-11">Add User to Bot</button>  */}
                       {(User_Role !=='BotUser' && User_Role !=='Viewer' ) && <Add_New_User_modal />}
                    </div>
                </div>                            
                
            </CardHeader>
            <CardBody className='no_padding'>
                <div className='sort_search'>
                    <Row>
                        <Col>
                            <div className='search'>
                                <div className="input-group">
                                    <Input onChange={serach_by_user_name} type="text" className="form-control h-40" aria-label="Search name" placeholder="Search name"/>
                                    <button className="btn btn-secondary padd_10" type="button"><i className="bx bx-search fs-20"></i></button>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className='sort'>
                            <select onChange={serach_by_user_role}  className="form-select h-40 mb-3" aria-label="Default select example">
                            <option value={''} > Sort by role                             
                            </option>
                                <option value={'BotAdmin'} > Bot Admin                              
                                </option>
                                <option value={'BotUser'} >Bot User                           
                                </option>
                                <option value={'Viewer'} >Viewer                           
                                </option>
                            </select>
                            </div>
                        </Col>
                    </Row>
                </div>
                <ListGroup className='border-none'>
                    {
                        bot_user.map((ele,i)=>{

                            return  <ListGroupItem key={i}>
                            <div className='details'>
                                <div className='left'>
                                    <div className="d-flex align-items-center">
                                        <div className="flex-shrink-0">
                                            <img src={ele.User_Image} alt="" className="avatar-xs rounded-circle" />
                                        </div>
                                        <div className="flex-grow-1 ms-2">
                                            <p className='mb_0'><b>{ele.USER_NAME}</b></p>
                                        </div>
                                    </div>
                                </div>
                                <div className='right'>
                                    <span className={`badge rounded-pill ${ 
                                                ele.Type === 'BotAdmin' 
                                                ? 'bg-primary-cust-button text-dark' 
                                                : ele.Type === 'Viewer' 
                                                ? 'bg-info-subtle-cust text-dark' 
                                                : ele.Type === 'BotUser' 
                                                ? 'bg-warning-cust text-dark' 
                                                : ''  // Fallback case if none of the roles match
                                            }`}> {ele.Type} </span>
                                    {(User_Role !=='BotUser' && User_Role !=='Viewer' ) &&<span><Edit_role_modal User_Name={ele.USER_NAME} Bot_ID={Bot_ID} User_Role={ele.Type} User_Group_ID={ele.User_Group_ID}/> </span>}
                                    { (User_Role !=='BotUser' && User_Role !=='Viewer' ) && <Button className="bg-transparent"><i onClick={()=>{onClick_Delete_User_From_Bot(ele)}} className="ri-delete-bin-line"></i></Button>}
                                
                                </div>
                            </div>
                        </ListGroupItem>

                        })
                    }
                   
                        
                    
                 
                </ListGroup>
            </CardBody>
        </Card>
    </div>
  )
}

export default BotUser
